<template>
  <div class="index-outer">
    <myheader></myheader>
    <div class="porderCenter">
      <!-- <div class="nav">
        <div :class="typeIndex == 0 ? 'active' : ''" @click="typeIndex = 0">
          个人订单
        </div>
        <div :class="typeIndex == 1 ? 'active' : ''" @click="typeIndex = 1">
          团队订单
        </div>
      </div> -->
      <div class="order-navs">
        <div
          v-for="(item, index) in navlist"
          :key="index"
          @click="navsindex = item.id"
          class="navs-item"
          :class="item.id == navsindex ? 'active' : 'noactive'"
        >
          <div>{{ item.name }}</div>
          <!-- <div
            class="borderBottom"
            :class="item.id == navsindex ? 'active' : ''"
          ></div> -->
        </div>
      </div>
      <div v-if="typeIndex == 0">
        <div
          class="orderDetails"
          v-for="(item, index) in DataList"
          :key="index"
        >
          <div class="detials-top">
            <div>创建时间：{{ item.createTime }}</div>
            <div style="display:flex;">
              <div
                class="cancel"
                @click="detail(item)"
                v-if="item.status == 1"
                style="color: red;margin-right:20px"
              >
                修改申请
              </div>
              <div
                class="cancel"
                @click="cancel(item.id)"
                v-if="item.status == 2 || item.status == 1"
              >
                取消参观
              </div>
            </div>

            <!-- <div>下单时间：{{ item.createTime }}</div> -->
          </div>
          <div class="detials-data">
            <div class="detials-data-item1">
              <div>团队类型：{{ item.classification | getType }}</div>
              <div>讲解方式： {{ item.explained | getExType }}</div>
            </div>
            <div class="detials-data-item1">
              <div>
                参观时间：{{ item.appointDate }} {{ item.appointTimeStart }}-{{
                  item.appointTimeEnd
                }}
              </div>
              <div>团队名称： {{ item.name }}</div>
            </div>
            <div class="detials-data-item1">
              <div>联系人姓名： {{ item.leader }}</div>
              <div>联系人手机号: {{ item.phone }}</div>
            </div>
            <!-- <div class="detials-data-item">身份证： {{ item.identity }}</div> -->
            <div class="detials-data-item1">
              <div>团队来源： {{ item.area }}</div>
              <div>参观人数: {{ item.num }}</div>
            </div>
            <!-- <div
              class="cancel"
              @click="cancel(item.id)"
              v-if="item.status == 2"
            >
              取消参观
            </div> -->
          </div>
        </div>
      </div>
      <div v-if="typeIndex == 1">
        <div
          class="orderDetails"
          v-for="(item, index) in DataList"
          :key="index"
        >
          <div class="detials-top">
            <div>订单编号：{{ item.id }}</div>
            <div>下单时间：{{ item.createTime }}</div>
            <div class="detials-top-right" @click="exportExcel(item.id)">
              <img src="../assets/download.png" alt="" width="15px" />
              团队人员名单
            </div>
            <div
              class="detials-top-right"
              v-if="item.status == 6"
              @click="$router.push('Pindex/?orderId=' + item.id)"
            >
              <img src="../assets/edit.png" alt="" width="15px" />
              重新提交修改
            </div>
          </div>
          <div class="detials-data">
            <div class="detials-data-item1">
              <div>
                预约时间：{{ item.appointDate }} {{ item.appointTimeStart }}-{{
                  item.appointTimeEnd
                }}
              </div>
              <div>团队名称：{{ item.name }}</div>
            </div>
            <div class="detials-data-item1">
              <div>领队姓名：{{ item.leader }}</div>
              <div>团队类型：{{ getType(item.type) }}</div>
            </div>
            <div class="detials-data-item1">
              <div>身份证：{{ item.identity }}</div>
              <div>手机号：{{ item.phone }}</div>
            </div>
            <div class="detials-data-item1">
              <div>
                是否需要讲解：{{ item.explained == 0 ? "不需要" : "需要" }}
              </div>
              <div>
                是否需要场地:{{ item.needSpace == 0 ? "不需要" : "需要" }}
              </div>
            </div>
            <div class="detials-data-item">备注：{{ item.remark }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import myheader from "../components/myheader.vue";
export default {
  data() {
    return {
      typeIndex: 0,
      //订单列表状态
      navsindex: 2,
      navlist: [
        {
          name: "待审核",
          id: 1,
        },
        {
          name: "待参观",
          id: 2,
        },

        {
          name: "已完成",
          id: 3,
        },
        {
          name: "已取消",
          id: 4,
        },
        {
          name: "已驳回",
          id: 6,
        },
      ],
      options: [
        {
          value: 0,
          label: "政府",
        },
        {
          value: 1,
          label: "国企",
        },
        {
          value: 2,
          label: "民营",
        },
        {
          value: 3,
          label: "外资合资",
        },
        {
          value: 4,
          label: "事业单位",
        },
        {
          value: 5,
          label: "大中小学",
        },
        {
          value: 6,
          label: "医院",
        },
        {
          value: 7,
          label: "其他",
        },
      ],
      DataList: [],
    };
  },
  components: {
    myheader,
  },
  watch: {
    typeIndex(val) {
      this.getList();
      if (val == 0) {
        this.navlist = [
          {
            name: "待审核",
            id: 1,
          },
          {
            name: "待参观",
            id: 2,
          },

          {
            name: "已完成",
            id: 3,
          },
          {
            name: "已取消",
            id: 4,
          },
          {
            name: "已驳回",
            id: 6,
          },
        ];
      }
      if (val == 1) {
        this.navlist = [
          {
            name: "已预约",
            id: 2,
          },
          {
            name: "已核销",
            id: 3,
          },
          {
            name: "已取消",
            id: 4,
          },
          {
            name: "已过期",
            id: 5,
          },
          {
            name: "已驳回",
            id: 6,
          },
          {
            name: "待审核",
            id: 1,
          },
        ];
      }
    },
    navsindex() {
      this.getList();
    },
  },
  created() {
    if (this.$route.query.typeIndex) {
      this.typeIndex = this.$route.query.typeIndex;
    }
    this.getList();
  },

  filters: {
    getType1(val) {
      let options = [
        {
          value: 0,
          label: "政府",
        },
        {
          value: 1,
          label: "国企",
        },
        {
          value: 2,
          label: "民营",
        },
        {
          value: 3,
          label: "外资合资",
        },
        {
          value: 4,
          label: "事业单位",
        },
        {
          value: 5,
          label: "大中小学",
        },
        {
          value: 6,
          label: "医院",
        },
        {
          value: 7,
          label: "其他",
        },
      ];
      let label;
      for (const iterator of options) {
        if (iterator.value == val) {
          label = iterator.label;
          break;
        }
      }
      return label;
    },
    getType(val) {
      let options = [
        {
          value: 0,
          label: "常规团队（20-50人）",
        },
        {
          value: 1,
          label: "中小学生团队（20-99人）",
        },
        {
          value: 2,
          label: "中小学生团队（大于100人）",
        },
        {
          value: 3,
          label: "社教活动(20-50人)",
        },
      ];

      let label;
      for (const iterator of options) {
        if (iterator.value == val) {
          label = iterator.label;
          break;
        }
      }
      return label;
    },
    getExType(val) {
      let options = [
        {
          value: 0,
          label: "馆方讲解",
        },
        {
          value: 1,
          label: "持证讲解",
        },
        {
          value: 2,
          label: "无需讲解",
        },
      ];

      let label;
      for (const iterator of options) {
        if (iterator.value == val) {
          label = iterator.label;
          break;
        }
      }
      return label;
    },
  },
  methods: {
    detail(item) {
      this.$router.push(
        "/Pindex?type=" + item.classification + "&&id=" + item.id
      );
    },
    getList() {
      if (this.typeIndex == 1) {
        this.$axios.get("/team/list/user/" + this.navsindex).then((res) => {
          this.DataList = res.data;
        });
      } else {
        this.$axios
          .get("/book/appointmentInfos?status=" + this.navsindex)
          .then((res) => {
            this.DataList = res.data.rows;
          });
      }
    },
    cancel(id) {
      this.$confirm("确定取消预约?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios.get("book/cancel?id=" + id).then(() => {
            this.getList(this.navsindex);
            this.$message({
              type: "success",
              message: "取消成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    getType(val) {
      return this.options.find((item) => item.value == val).label;
    },
    // 导出excel数据
    exportExcel(id) {
      this.$axios.get("/team/export?id=" + id).then((res) => {
        if (res.code == 200) {
          console.log(res.msg);
          window.location.href =
            "https://" +
            process.env.VUE_APP_BASE_API +
            "/common/download?fileName=" +
            encodeURI(res.msg) +
            "&delete=" +
            true;
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.porderCenter {
  width: 820px;
  margin: 0 auto;
  padding-bottom: 100px;
  font-size: 16px;
  .nav {
    margin-top: 40px;
    display: flex;
    div {
      width: 140px;
      line-height: 42px;
      border: 1px solid rgb(132, 132, 132);
      border-radius: 27.5px;
      color: #848484;
      text-align: center;
      margin-right: 20px;
      cursor: pointer;
    }
    .active {
      border: 1px solid rgb(170, 32, 32);
      border-radius: 27.5px;
      color: #aa2020;
    }
  }
  .order-navs {
    display: flex;
    margin-top: 40px;
    margin-bottom: 40px;
    .navs-item {
      width: 60px;
      margin-right: 38px;
      font-size: 20px;
      text-align: center;
      padding-bottom: 3px;
      cursor: pointer;
    }
    .active {
      color: #aa2020;
      border-bottom: 3px solid #aa2020;
    }
    .noactive {
      color: rgba(0, 0, 0, 0.51);
      border-bottom: 3px solid transparent;
    }
  }
  .orderDetails {
    margin-bottom: 30px;
    .detials-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: rgba(0, 0, 0, 0.51);
      background: rgba(196, 196, 196, 0.26);
      line-height: 40px;
      padding: 0 30px;
      box-sizing: border-box;
      .detials-top-right {
        color: #aa2020;
        font-size: 12px;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          margin-right: 5px;
        }
      }
    }
    .detials-data {
      padding: 20px 30px 50px 20px;
      box-sizing: border-box;

      .cancel {
        width: 52px;
        line-height: 34.5px;
        text-align: center;
        background: rgba(170, 32, 32, 0.18);
        border-radius: 3px;
        color: #aa2020;
        margin-top: 10px;
        float: right;
        cursor: pointer;
      }
      .detials-data-item {
        font-weight: 600;
        line-height: 40px;
      }
      .detials-data-item1 {
        display: flex;
        font-weight: 600;
        line-height: 40px;
        div {
          width: 50%;
        }
      }
    }
  }
}
</style>